import {
  Flex,
  Space,
  Typography,
} from 'antd'
import React, { useMemo } from 'react'

import { FanReportsLabel } from '@/constants/fan-reports-chart-colors'
import { FansReports } from '@/model/analytics'

import SectionTitle from '../section-title'

import FansReportsLineChart from './fans-reports-line-chart'

const { Text } = Typography

export type FansReportsChartData = { name: string, count: number, dateStr: string }

export interface FansReportsNewFansProps extends Partial<
  Pick<FansReports, 'renews' | 'newSubscribers' | 'datesStr'>
> {
  featureTimezone?: string
}

export default function FansReportsNewFans({
  renews,
  newSubscribers,
  datesStr,
  featureTimezone,
}: FansReportsNewFansProps) {
  const data = useMemo<FansReportsChartData[]>(() => {
    if (!datesStr || !renews || !newSubscribers) return []
    return datesStr.map((dateStr, i) => {
      return [
        { name: FanReportsLabel.All, count: renews[i] + newSubscribers[i], dateStr },
        { name: FanReportsLabel.Renews, count: renews[i], dateStr },
        { name: FanReportsLabel.NewSubscribers, count: newSubscribers[i], dateStr },
      ]
    }).flat()
  }, [datesStr, newSubscribers, renews])

  return (
    <Flex vertical gap={16}>
      <Space>
        <SectionTitle
          title="New fans (growth & trends)"
          tooltip="Growth and trends of new fans during this period, sourced from OnlyFans’ Statistics"
        />
        <Text strong style={{ color: 'var(--chart-timezone-color)' }}>{featureTimezone}</Text>
      </Space>
      <Flex vertical>
        <FansReportsLineChart data={data} />
      </Flex>
    </Flex>
  )
}
